const AesStatusNotificationApiUrls = {
  GET: `${process.env.REACT_APP_USER_AES_URL}/aes/shipment/status-notification/get`,
  POST: `${process.env.REACT_APP_USER_AES_URL}/aes/shipment/status-notification/create`,
  PUT: `${process.env.REACT_APP_USER_AES_URL}/aes/shipment/status-notification/update`,
  DELETE: `${process.env.REACT_APP_USER_AES_URL}/aes/shipment/status-notification/delete`,
};

export default AesStatusNotificationApiUrls
